<!--
================================================
Un composant permettant d'afficher un tag

Url d'accès :
http://localhost:8080/fr/samsonite/timeTracking
http://localhost:8080/fr/samsonite/samsonite-workspace/tags
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <span class="TagComp tags has-addons" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

      <span v-if="tag.isArchived!=true"
                class="tag has-text-weight-normal mr-2 is-rounded has-text-grey" v-bind:style="{ boxShadow: '0 0 3px 0px #'+tag.color}">
          <span class="mr-1" v-bind:style="{color:'#'+ tag.color}"><font-awesome-icon :icon="['fas', 'tag']"/></span>
          <span class="name">{{ tag.name }}</span>
        </span>

        <span v-else
                class="tag archived has-text-weight-normal mr-2 is-rounded has-text-grey"
                v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', trigger: 'mouseenter'}"
                :content="$t('leTagEstArchivé')">
          <span class="mr-1"><font-awesome-icon :icon="['fas', 'tag']"/></span>
          <span class="name">{{ tag.name }}</span>
        </span>

    </span>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'

export default {
  name: 'TagComp', //utile dans vue dev tool
  mixins: [
  ],
  // components: {},


  props: {
    /** pour typage et validation voir :
     *  https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
     *  https://fr.vuejs.org/v2/guide/components-props.html#Validation-des-props
     **/
    //
    tag: {
      type: Object, // un objet tag
      required: false,
      default: false,
      // ou si l'on veut que défaut soit une  fonction ex : pour retourner un objet vide
      // default: () => ({ })
    },
  },
  data: function () {
    return {
      // =================================================================
    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay
    }),

    //----------------------------------------------



  },


  methods: {
  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {

  },

}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/globalVar.scss";
@import "../../assets/css/bulmaCustom.scss";
///*@import "../assets/css/bulmaResponsiveDep.scss";*/

.TagComp {

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////

  .archived{
    color:#ccc;
    background-color: transparent ;
    border: dashed 1px #ddd;
  }

  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {

    .tag{
      color: $darkContrastTxt !important;
      background-color: $darkBg3;
    }
    .archived{
      color:lighten($darkBg,15%)   !important;
      border: dashed 1px lighten($darkBg,15%) !important;
    }
  }

}
</style>
